import { render, staticRenderFns } from "./ConsultaSevComponent.vue?vue&type=template&id=2796ce6d"
import script from "./ConsultaSevComponent.vue?vue&type=script&lang=js"
export * from "./ConsultaSevComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports